export default __webpack_public_path__ + "static/media/Bandeau-catalogue-desktop.ccf27c1d.png";